import React from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player/youtube';

export default function VideoPlayerYoutube({ url }) {
  return (
    <div className="video-player-wrapper">
      <ReactPlayer
        url={url}
        controls
        width="100%"
        height="100%"
        className="video-player"
      />
    </div>
  );
}

VideoPlayerYoutube.propTypes = {
  url: PropTypes.string.isRequired,
};
